import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaLimpiezaCamiones from './TablaLimpiezaCamiones';

const LimpiezaCamiones: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaLimpiezaCamiones />
    </Box>
  );
};

export default LimpiezaCamiones;
